import { socket } from './modules/socket';
import store from '.';
import Sockets from './modules/socket';
import jitsi from './modules/jitsi';
import Session from './modules/session';
import Stage from './modules/stageState';
import Board from './modules/board';
import Interface from './modules/interface';
import Element from './modules/element';

const eventsPrefix = 'SOCKET_ON_';

const BoardActions = Object.keys(Board.actions || {});
const ElementActions = Object.keys(Element.actions || {});
const InterfaceActions = Object.keys(Interface.actions || {});
const JitsiActions = Object.keys(jitsi.actions || {});
const SessionActions = Object.keys(Session.actions || {});
const SocketActions = Object.keys(Sockets.actions || {});
const StageActions = Object.keys(Stage.actions || {});

[
  ...ElementActions,
  ...BoardActions,
  ...InterfaceActions,
  ...JitsiActions,
  ...SessionActions,
  ...SocketActions,
  ...StageActions,
].forEach(key => {
  if (!key.includes(eventsPrefix)) return;
  const [, eventName] = key.split(eventsPrefix);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  socket.on(eventName.toLowerCase(), (payload: any) => {
    store.dispatch(key, payload);
  });
});
